import Search from 'components/users/Search';
import Users from 'components/users/Users';
import React from 'react';

const Home = () => (
  <>
    <Search />
    <Users />
  </>
);

export default Home;
